export const NAMESPACE = "ResourcesSideBarSpace";

export const SIDEBAR_INSTANCE_ID = "resources_sidebar_instance_id";

export const MOCK_WIKI_PAGES = [
  {
    id: 1,
    image:
      "https://cdn.prod.website-files.com/627d5c68d5739644034cfd28/6565804dd006b23a39994565_sessionboard-flywheel.jpg",
    title: "Conference Wiki FAQ",
    text: "Get answers to commonly-asked questions here!"
  },
  {
    id: 2,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ80sJepvo_9pZb_W40yO4tv_Hp93qTvwUyNw&s",
    title: "Conference Wiki MAP",
    text: "Get answers to commonly-asked questions here!"
  },
  {
    id: 3,
    image:
      "https://cdn.prod.website-files.com/627d5c68d5739644034cfd28/6284bde1e849fa104e349288_sessionboard-preview.png",
    title: "How to visualize your data",
    text: "Get answers to commonly-asked questions here!"
  },
  {
    id: 3,
    image:
      "https://cdn.prod.website-files.com/627d5c68d5739644034cfd28/6565804dd006b23a39994565_sessionboard-flywheel.jpg",
    title: "How to visualize your data",
    text: "Get answers to commonly-asked questions here!"
  }
];

export const MOCK_QUICK_LINKS = [
  {
    id: 1,
    url: "/",
    text: "Tickets",
    icon: "material-icons,local_activity",
    color: "#DA8B4F"
  },
  {
    id: 2,
    url: "/",
    text: "Hotel",
    icon: "material-icons,home",
    color: "#8156BE"
  },
  {
    id: 3,
    url: "/",
    text: "Location 1",
    icon: "material-icons,location_on",
    color: "#CB5F51"
  },
  {
    id: 4,
    url: "/",
    text: "Location 2",
    icon: "material-icons,location_on",
    color: "#CB5F51"
  },
  {
    id: 4,
    url: "/",
    text: "Location 2",
    icon: "material-icons,location_on",
    color: "#CB5F51"
  }
];

export const RESOURCES_FLYOVER_TABS_INSTANCE_ID =
  "resourcesFlyOverTabsInstanceId";
